export function getHashParam() {
  const params = new URLSearchParams(window.location.search);

  if (!params.has("hash")) throw new Error("Hash parameter is missing");

  const value = params.get("hash");

  if (!value || value.trim() === "") throw new Error("Hash parameter is empty");

  return value;
}

export function extractParamsFromBase64(base64Input) {
  const decoded = decodeBase64Query(base64Input);

  if (decoded === null) return {};

  return parseQueryParams(decoded);
}

function decodeBase64Query(base64Input) {
  try {
    const normalized = base64Input
      .replace(/-/g, "+")
      .replace(/_/g, "/");

    const padded = normalized + "===".slice((normalized.length + 3) % 4);

    return decodeURIComponent(
      Array.from(atob(padded), char => '%' + char.charCodeAt(0).toString(16).padStart(2, '0'))
        .join('')
    );
  } catch (e) {
    console.error("Invalid Base64 input:", e);

    return null;
  }
}

function parseQueryParams(queryString) {
  const params = {};

  if (!queryString) return params;

  // Entferne eventuell vorhandenes führendes Fragezeichen (?)
  const clean = queryString.replace(/^\?/, "");

  for (const part of clean.split("&")) {
    if (!part.includes("=")) continue;

    const [key, value] = part.split("=").map(decodeURIComponent);
    params[key] = value;
  }

  return params;
}
